export const helpCenterID = process.env.NEXT_PUBLIC_HELP_CENTER_APP_ID;
